import React, { useEffect, useState } from 'react';

import IbAccountWidget from '../components/IbAccountWidget';
import { AGENTS_DEFAULT_PATH, logoutUser, IUserProfile, getProfileAsync } from '../utils/oidcUtil';
import { AUTH_TYPE, GAMMA_LOGOUT_PATH } from '../utils/configUtil';
import { AuthenticationTypes } from '../constants';

const IbAccountWidgetWrapper: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<IUserProfile>();

  useEffect(() => {
    getProfileAsync().then(setCurrentUser);
  }, []);

  const onLogout = async () => {
    switch (AUTH_TYPE) {
      case AuthenticationTypes.DEFAULT:
        await logoutUser({ state: AGENTS_DEFAULT_PATH });
        return;
      case AuthenticationTypes.ELMA365:
        window.location.href = GAMMA_LOGOUT_PATH;
        return;
    }
  };

  return <IbAccountWidget currentUser={currentUser} onLogout={onLogout} />;
};

export default IbAccountWidgetWrapper;
